import { useMutation } from '@tanstack/react-query';
import { useSnackbar } from 'notistack';

import { publishStrategyToBorr } from '../../../../api';
import { ApiDataResponse } from '../../../../api/types/response';

export const useBorr = (strategyId: string) => {
  const { enqueueSnackbar } = useSnackbar();

  const onSuccess = (result: Pick<ApiDataResponse<unknown>, 'success' | 'errorMessage'>) => {
    if (!result.success) {
      enqueueSnackbar(result.errorMessage || 'Ошибка', { variant: 'error' });
      return;
    }
    enqueueSnackbar('Успешно');
  };

  const onError = (e: unknown) => {
    enqueueSnackbar(String(e), { variant: 'error' });
  };

  const publishMutation = useMutation({ mutationFn: () => publishStrategyToBorr(strategyId), onSuccess, onError });

  return {
    loading: publishMutation.isPending,
    onPublishToBorr: () => publishMutation.mutate(),
  };
};
